export default __webpack_public_path__ + "static/media/Class_Lessons.0fe70fda.svg";